import React from 'react';
import { TRACKING } from 'common/constants/constants';
import pdtImage from 'images/pdtCta.jpg';
import CtaPage from 'components/CtaPage';
import { TEXT_POSITION } from 'components/CtaPage/constants';

const SECTION_TYPES = {
  ACCURACY_SCORES: 'ACCURACY_SCORES',
  METRICS: 'METRICS',
  OVER_TIME: 'OVER_TIME'
};

const TEXTS = {
  [SECTION_TYPES.ACCURACY_SCORES]:
    'Project Delivery Tracker visualizes project delivery risk ' +
    'across sprints. Metrics like Planning Accuracy and Team ' +
    'Capacity provide insight into sprint health and expose potential delay risks.',
  [SECTION_TYPES.METRICS]:
    'The Delivery, Investment, and Effort dashboards ' +
    'breakdown the numbers into more consumable data points that help project ' +
    'leaders identify what is happening and where they can improvement.',
  [SECTION_TYPES.OVER_TIME]:
    'Keeping a project on track over multiple sprints requires a holistic ' +
    'data set that identifies performance trends in terms of executed work, ' +
    'issue type investment and people effort.'
};

const ProjectsCta = () => (
  <CtaPage
    textsMap={TEXTS}
    page={TRACKING.PAGES.PROJECTS}
    pageTab={TRACKING.PAGE_TABS.PROJECTS_CTA}
    buttonLineProps={{
      textWidth: '65%',
      leftText: 'UNLOCK PROJECT DELIVERY TRACKER TO UNCOVER RISKS',
      buttonText: 'BOOK A DEMO NOW'
    }}
    backgroundImage={pdtImage}
    sections={[
      {
        sectionType: SECTION_TYPES.ACCURACY_SCORES,
        buttonPosition: {
          left: '55%',
          top: '14rem'
        },
        coverProps: {
          height: '18.7rem',
          width: '100%',
          position: { top: 0 }
        },
        textPosition: { right: TEXT_POSITION, top: '11rem' }
      },
      {
        sectionType: SECTION_TYPES.METRICS,
        buttonPosition: {
          left: '25%',
          top: '27rem'
        },
        coverProps: {
          height: '30.75rem',
          width: '60%',
          position: { bottom: 0, left: 0 }
        },
        textPosition: { left: TEXT_POSITION, bottom: '10rem' },
        isTextLeft: true
      },
      {
        sectionType: SECTION_TYPES.OVER_TIME,
        buttonPosition: {
          right: '21%',
          bottom: '9.5rem'
        },
        coverProps: {
          height: '30.75rem',
          width: '40%',
          position: { bottom: 0, right: 0 }
        },
        textPosition: { right: TEXT_POSITION, bottom: '7rem' }
      }
    ]}
  />
);

export default ProjectsCta;
